module.exports = __webpack_public_path__ + "img/wifi.4a2a9ac.svg";